import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraButton } from '@mono/ui-components/ensigns';
import { SpecraEmptyState, SpecraInlineBanner } from '@mono/ui-components/lieutenants';
import { useEffect, useState } from 'react';
import { CenterEditor } from '../../PricingWorkspace/CenterEditor';
/** PRP-26 retains the existing editors and explicit Save until their patch/autosave upgrade. */ export function LegacyPricingNode({ projectId, pricing, node, clinNumber, tierId, canEdit, saving, error, onSave, onNavigate }) {
    const [draft, setDraft] = useState(pricing);
    const [dirty, setDirty] = useState(false);
    useEffect(()=>{
        if (!dirty) setDraft(pricing);
    }, [
        pricing,
        dirty
    ]);
    const update = (data)=>{
        setDraft((p)=>({
                ...p,
                ...data
            }));
        setDirty(true);
    };
    const selected = node === 'indirects' ? 'indirect' : node === 'clins' ? clinNumber : node === 'tiers' ? tierId ? `shared-tier-${tierId}` : undefined : node;
    if (clinNumber && !draft.clinPricing?.some((c)=>c.clinNumber === clinNumber) || tierId && !draft.sharedTierConfigs?.some((t)=>t.id === tierId)) return /*#__PURE__*/ _jsx(SpecraEmptyState, {
        title: clinNumber ? 'CLIN not found' : 'Shared tier not found'
    });
    return /*#__PURE__*/ _jsxs("div", {
        className: "space-y-4",
        children: [
            node === 'clins' && /*#__PURE__*/ _jsx("div", {
                className: "flex flex-wrap gap-2",
                children: draft.clinPricing?.map((c)=>/*#__PURE__*/ _jsxs(SpecraButton, {
                        variant: "secondary",
                        onClick: ()=>onNavigate(`clin/${c.clinNumber}`),
                        children: [
                            "CLIN ",
                            c.clinNumber
                        ]
                    }, c.clinNumber))
            }),
            node === 'tiers' && /*#__PURE__*/ _jsx("div", {
                className: "flex flex-wrap gap-2",
                children: draft.sharedTierConfigs?.map((t)=>/*#__PURE__*/ _jsx(SpecraButton, {
                        variant: "secondary",
                        onClick: ()=>onNavigate(`tiers/${t.id}`),
                        children: t.tierLabel
                    }, t.id))
            }),
            selected ? /*#__PURE__*/ _jsx("fieldset", {
                disabled: !canEdit || saving,
                className: !canEdit ? 'pointer-events-none' : undefined,
                children: /*#__PURE__*/ _jsx(CenterEditor, {
                    projectId: projectId,
                    selectedNodeId: selected,
                    pricing: draft,
                    clinPricing: draft.clinPricing ?? [],
                    rateCard: draft.rateCard,
                    sharedTierConfigs: draft.sharedTierConfigs ?? [],
                    indirectConfig: draft.globalIndirectConfig,
                    onCLINChange: (clin)=>update({
                            clinPricing: draft.clinPricing?.map((c)=>c.clinNumber === clin.clinNumber ? clin : c)
                        }),
                    onRateCardChange: (rateCard)=>update({
                            rateCard
                        }),
                    onIndirectConfigChange: (globalIndirectConfig)=>update({
                            globalIndirectConfig
                        }),
                    onSharedTierChange: (tier)=>update({
                            sharedTierConfigs: draft.sharedTierConfigs?.map((t)=>t.id === tier.id ? tier : t)
                        }),
                    onSelectNode: (id)=>onNavigate(id.startsWith('shared-tier-') ? `tiers/${id.slice(12)}` : `clin/${id}`)
                })
            }) : /*#__PURE__*/ _jsx(SpecraEmptyState, {
                title: node === 'clins' ? 'Choose a CLIN' : 'Choose a shared tier'
            }),
            canEdit && dirty && /*#__PURE__*/ _jsx(SpecraButton, {
                disabled: saving,
                onClick: async ()=>{
                    try {
                        await onSave({
                            clinPricing: draft.clinPricing,
                            globalIndirectConfig: draft.globalIndirectConfig,
                            sharedTierConfigs: draft.sharedTierConfigs
                        });
                        setDirty(false);
                    } catch  {
                    /* keep draft */ }
                },
                children: saving ? 'Saving…' : 'Save changes'
            }),
            error && /*#__PURE__*/ _jsxs(SpecraInlineBanner, {
                tone: "danger",
                children: [
                    "Not saved: ",
                    error.message
                ]
            })
        ]
    });
}
